import { render, staticRenderFns } from "./menuSwitchImg.vue?vue&type=template&id=67653a22&scoped=true&"
import script from "./menuSwitchImg.vue?vue&type=script&lang=js&"
export * from "./menuSwitchImg.vue?vue&type=script&lang=js&"
import style0 from "./menuSwitchImg.vue?vue&type=style&index=0&id=67653a22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67653a22",
  null
  
)

export default component.exports